import React, { useState, useEffect } from 'react';
import { GlobalStyle, Box, Goals} from './style';
import Axios from 'axios';
import Foot from './foot';
import {BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";


function Home() {
    const [count, setCount] = useState(
        +localStorage.getItem('nudes') 
    );
    
    const [current, setCurrent] = useState('goals.jpg')
    
    // load #1 MEME TO BE MAIN IMAGE
    useEffect(() => {
        document.title = `You have seen tain nude ${count} times`
        Axios.get('http://memerepository.asuscomm.com/api').then(response => {
        let data = response.data[0].image
        setCurrent(`http://memerepository.asuscomm.com/${data}`)
    } )
    
    },[current, count])
    
    function nudeHandler(){
        setCount(count + 1)
        localStorage.setItem('nudes', count + 1);
        window.location.assign('http://memerepository.asuscomm.com/10')
    }
    
    return(
    <div>
        <Box>
            <Goals src={current}  onClick={() => nudeHandler()}/>
        </Box>
        <Foot num={count}/>
   </div> 
   )
}

export default Home;